import { mapGetters } from 'vuex'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { manuscript } from '@/api/manuscript'
import { inviteMacademic } from '@/api/macademic'
import {
  PRE_DECISION,
  FIRST_DECISION,
  FINAL_DECISION,
  DECISION_STATUS
} from '@/utils/dict'
import { getUploadConfig } from '@/utils/upload'
import check from '@/utils/check'
// import SendEmail from '../../editorial-office/manuscripts/dialog/send-email.dialog'
import reportDetail from './report-detail'
import customerReviewQuestion from '@/components/question.vue'

export default {
  components: {
    // SendEmail,
    reportDetail,
    customerReviewQuestion
  },
  data() {
    return {
      // 取回数据
      reviewsResponse: {}, // 审稿人信息
      journalResponse: {}, // 稿件信息
      showVersion1: true,
      showDecision1: false,
      // 填写数据 外编信息
      reviews: {
        // reviewerList: [
        //   {
        //     firstName: '',
        //     lastName: '',
        //     email: ''
        //   }
        // ]
        decisionStatus: ''
      },
      //
      rules: {},
      reviewerFileList: [],
      isMoreText: false,
      isMoreText1: false,
      termList: PRE_DECISION,
      termListStatus: DECISION_STATUS,
      routeStatu: '',
      type: '',
      parmas: {
        editorNotes: ''
      },
      isView: false,
      showExternal: false,
      loading: false,
      showEditor: false,
      showAuthor: false,
      showReport: false,
      activeData: {},
      activeKey: []
    }
  },
  mounted() {
    this.routeStatu = this.$route.name
    this.getData()
    this.getRules()
    if (this.type === 'FIRST_CHECK' || this.type === 'FINAL_CHECK') {
      this.rules.authorNotes[0].required = false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      manuscriptType: 'getManuscriptType',
      country: 'getCountry',
      title: 'getTitle',
      user: 'getUser',
      domain: 'getDomain',
      degree: 'getDegree'
    })
  },
  watch: {
    // isMoreText:
  },
  methods: {
    getRules() {
      this.rules = {
        authorNotes: [
          {
            required: true,
            message: 'Comments to Author' + this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },

    // 获取数据
    async getData() {
      let routeName = this.$route.name
      let { sign, manuscriptId } = this.$route.query
      let id = this.$route.params.id
      let type = this.$route.params.type
      let data = {
        sign
      }
      if (routeName === '/academic-menu/academic/detail') {
        this.isView = true
      } else {
        this.isView = false
      }
      switch (type) {
        case 'PRE_CHECK':
          this.termList = PRE_DECISION
          this.type = 'PRE_CHECK'
          break
        case 'FIRST_CHECK':
          this.termList = FIRST_DECISION
          this.type = 'FIRST_CHECK'
          break
        case 'FINAL_CHECK':
          this.termList = FINAL_DECISION
          this.type = 'FINAL_CHECK'
          break
        default:
          this.termList = PRE_DECISION
          this.isView = true
          this.type = 'PRE_CHECK'
      }
      manuscript.info(manuscriptId, type, data).then(res => {
        this.journalResponse = res ? res : []
      })
      inviteMacademic.reviewerAll(id, type).then(res => {
        this.reviewsResponse = res ? res : {}
        let flagSign = {}
        let flag = false
        let signReverse = this.reviewsResponse.signList
          ? this.reviewsResponse.signList.slice().reverse()
          : []
        let reviewerDecisionReverse = this.reviewsResponse.reviewerDecisionList
          ? this.reviewsResponse.reviewerDecisionList.slice().reverse()
          : []
        for (let i = 0; i < signReverse.length; i++) {
          let sign = signReverse[i]
          for (let j = 0; j < reviewerDecisionReverse.length; j++) {
            let decision = reviewerDecisionReverse[j]
            if (decision.sign == sign) {
              flagSign = decision
              flag = true
              break
            } else {
              flag = false
            }
          }
          if (flag) {
            break
          }
        }
        if (flagSign) {
          const data = this.reviewsResponse.reviewerList.filter(
            item => item.id === flagSign.personId
          )
          if (data) {
            this.activeData = flagSign
            this.activeData.__index = 0
            this.activeKey[0] = flagSign.personId
            this.activeKey[1] = flagSign.sign
          }
        }
      })
      inviteMacademic.history(id, type).then(res => {
        this.reviews = res ? res : {}
        this.reviewerFileList =
          (this.reviews && this.reviews.academicFileList) || []
        this.reviews.reviewerList.push({
          firstName: '',
          lastName: '',
          email: ''
        })
      })
    },

    onChange() {},

    // 文件修改
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }

      // const MS = 200
      // const maxSize = file.size / 1024 / 1024 < MS
      // if (!maxSize) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
      //   })
      //   return false
      // }
    },
    async addFile(file) {
      const flag = this.reviewerFileList.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            description: '',
            path: '',
            file: file,
            authorShowed: val.authorShowed ? val.authorShowed : true,
            sort: val.sort
          }
          return true
        }
      })
      const path = `publisher/${this.publisherId}/manuscript/${
        this.$route.query.manuscriptId
      }/submit/${help.guid()}`

      this.uploadProgress = {
        current: 0,
        total: this.reviewerFileList.length
      }
      const pro_all = []
      this.loading = true
      if (!flag) {
        this.reviewerFileList.push({
          name: file.name,
          size: file.size,
          // description: '',
          path: '',
          file: file,
          authorShowed: true,
          sort: ''
        })
      }
      this.reviewerFileList.forEach((item, index) => {
        item.sort = item.sort ? item.sort : index
        if (!item.path) {
          pro_all[index] = getUploadConfig(item.file, path).then(res => {
            if (res && !res.includes('err:')) {
              this.uploadProgress.current++
            }
            return res
          })
        } else {
          this.uploadProgress.current++
        }
      })
      const reses = await Promise.all(pro_all)
      this.loading = false
      this.errArr = []
      reses.forEach(item => {
        if (item && item.includes('err:')) {
          this.errArr.push(item.split(':')[1])
        }
      })

      this.reviewerFileList.forEach((item, index) => {
        if (!item.path && reses[index] && !reses[index].includes('err:')) {
          item.path = reses[index]
        }
        item.sort = index
      })

      if (this.errArr.length) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        this.uploadProgress = {
          current: 0,
          total: 0
        }
        return
      }
    },

    // 文件列表
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          this.reviewerFileList.splice(index, 1)
        } else {
          this.reviewerFileList = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },

    // 保存
    async commit() {
      let flag = this.$refs['reviews-commit'].validate()
      if (this.reviews.reviewerList) {
        for (let i = 0; i < this.reviews.reviewerList.length; i++) {
          if (
            !this.reviews.reviewerList[i].firstName &&
            !this.reviews.reviewerList[i].lastName &&
            !this.reviews.reviewerList[i].email
          ) {
            this.reviews.reviewerList.splice(i, 1)
          }
        }
        for (let i = 0; i < this.reviews.reviewerList.length; i++) {
          if (
            this.reviews.reviewerList[i].email &&
            !check.email(this.reviews.reviewerList[i].email)
          ) {
            this.$message.error({
              title: 'Error',
              content: 'Please enter the correct email address!'
            })
            return
          }
        }
      }

      this.parmas = Object.assign(this.reviews, {
        manuscriptId: this.$route.query.manuscriptId,
        sign: this.$route.query.sign,
        academicFileList: this.reviewerFileList
        // version:this.
      })
      if (!this.parmas.decisionStatus) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a decision option!'
        })
        return
      }

      if (flag) {
        // console.log(this.parmas, '参数')
        await inviteMacademic.decision(this.type, this.parmas)
        this.$message.success({
          title: 'Success',
          content: 'Thank you for submitting your decision!'
        })
        this.$router.push('/academic-menu/academic?status=COMPLETED_DECISION')
      }
    },

    // 审稿人展开

    togalReport(item, type) {
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse = JSON.parse(JSON.stringify(this.reviewsResponse))
    },

    // 状态切换
    changeStatus(statu) {
      this.reviews.decisionStatus = statu
      if (this.type === 'FIRST_CHECK' || this.type === 'FINAL_CHECK') {
        this.rules.authorNotes[0].required = false
      } else {
        if (['PEER_REVIEW', 'ACCEPT_CURRENT'].includes(statu)) {
          this.rules.authorNotes[0].required = false
        } else {
          this.rules.authorNotes[0].required = true
        }
      }
    },
    showReportDetail(id, sign, index) {
      // 显示审稿报告
      // this.showReport = true
      this.activeKey[0] = id
      this.activeKey[1] = sign
      const tempArr =
        this.reviewsResponse.reviewerDecisionList &&
        this.reviewsResponse.reviewerDecisionList.filter(
          ele => ele.personId === id && sign == ele.sign
        ) &&
        this.reviewsResponse.reviewerDecisionList.filter(
          ele => ele.personId === id && sign == ele.sign
        ).length > 0 &&
        this.reviewsResponse.reviewerDecisionList.filter(ele => {
          return ele.personId === id && sign == ele.sign
        })[0]
      this.activeData = tempArr
      this.activeData.__index = index
    },
    addReviewer() {
      this.reviews.reviewerList.push({
        firstName: '',
        lastName: '',
        email: ''
      })
    },
    cancel() {
      this.showReport = false
    },
    delReviewer(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this data?',
        content:
          'Please be aware of once this data is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        this.reviews.reviewerList.splice(index, 1)
        this.$message.success({
          title: 'Success',
          content: 'This Data has been deleted!'
        })
      })
    },
    showDecision(item) {
      let link = `/academic-menu/academic/detail/${item.decisionType}/${item.id}?manuscriptId=${item.manuscriptId}&sign=${item.sign}&status=${item.status}`
      window.open(link)
    }
  }
}
